export default {
  BASE_URL: process.env.REACT_APP_API_URL,
  USER_REGISTER: '/service/services',
  GENERATE_URL: '/service/services/generate',
  // GET_FORM_DATA: '/registration/public/',
  GET_FORM_DATA_JAVA:'/registration/public/',
  GET_VALID_REGISTRATION_NUMBER: '/company/public/br/',
  GET_VALID_APPLICANT_EMAIL: '/user/public/email?',
  TENANT_ACCOUNT_TYPES: '/tenant/public/account-types',
  USER_REGISTER_JAVA: '/user/public/register',
  GENERATE_URL_JAVA:'registration/public/register-link'
};
